import React from 'react';

const MinisiteConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/Minisite',
      exact: true,
      component: React.lazy(() => import('./minisite_list'))
    }
  ]
};

export default MinisiteConfig;
